<template>
  <v-dialog v-model="show" persistent max-width="350">
    <v-card>
      <v-card-title>Update from accounting</v-card-title>
      <v-divider/>
      <v-card-text class="pt-4">
        You have asked to update {{name}} from the accounting system.
        <div class="mt-4 font-weight-bold">
          <v-icon color="warning" large>mdi-alert</v-icon>
          Any changes made in PŪRTRAK will be overridden with accounting system values.</div>
      </v-card-text>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer></v-spacer>
        <v-btn color="primary" plain @click="update">Update</v-btn>
        <v-btn color="primary" @click="cancel">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'UpdateObjectFromAccounting',
	props: {
    value: {type:Boolean,required:true},    // Show dialog
    name: {type:String, required:false,default:'this item'},
  },
  data() {
    return {
      show: false,
    }
  },
  watch: {
    value() {
      this.show = this.value;
    }
  },
  methods: {
    cancel() {
      this.show = false;
      this.$emit('input', false);
    },
    update() {
      this.show = false;
      this.$emit('update')
      this.$emit('input', false);
    }
  }
}
</script>